@if (isLoading()) {
<sura-mobility-loader />
} @else {
<banner-app [Fixtop]="''" [retroSelected]="true" [infoDueno]="true" [showPromo]="true"></banner-app>

<div class="container my-lg-5">
  <div class="row sura-main-container__row">
    <div class="col-lg-6 d-flex flex-column text-center sura-hero px-5">
      <div class="order-1 order-lg-0 sura-hero__text">
        <h3 class="sura-hero__title">Estamos procesando tu pago</h3>
        <p class="sura-hero__subtitle">
          En este momento estamos validando la información del pago.
          Te enviaremos un correo con la confirmación y los detalles de tu
          seguro.
        </p>
      </div>
      <div class="order-0 order-lg-1">
        <img class="sura-hero__image" src="./assets/img/ProcesandoPago.png"
          alt="Ilustración de un reloj y escudo simbolizando el procesamiento del pago." />
      </div>
    </div>

    <div class="col-lg-6 px-5">
      <h4 class="sura__heading--underlined">Información de pago</h4>

      <dl class="sura-dl sura__mb--big">
        <dt>Estado</dt>
        <dd>Pendiente</dd>

        <dt>Valor</dt>
        <dd>
          {{
          cotizacionData()?.data?.plan?.price?.full?.amount || 0
          | customNumberFormat
          }}
        </dd>

        <dt>Referencia de pago</dt>
        <dd>{{ cotizacionData()?.data?.pre_policy_number }}</dd>

        <dt>Forma de pago</dt>
        <dd>{{ paymentFrequencyText() }}</dd>
      </dl>

      <h4 class="sura__heading--underlined">Resumen de compra</h4>

      <sura-summary-plan-card [pagoPlan]="pagoPlanForChild()" [isSummary]="false" [valorAPagar]="valorAPagar()"
        [valorMes]="valorMes()" [tipoPago]="paymentFrequencyText()" [fecha]="fecha()"
        [cuidaCirculacion]="cuidaCirculacion()" [coveragesIncluded]="coveragesIncluded()"
        [vehicleDescription]="vehicleDescription()" [ownerFullName]="ownerFullName()"
        [ownerDocument]="ownerDocument()" />

      <button type="button" class="sura-btn" (click)="entendido()">
        Entendido
      </button>
    </div>
  </div>
</div>

<app-footer-app class="footer-fixed" />

}